/**
 * Chemins standard des logos module (générés par scripts/sync-module-logos.mjs).
 * Registre corporate : core/logos/logo-map/logo-registry.csv
 */
export const MODULE_LOGO_PATH = "assets/img/logo.png";
export const MODULE_LOGO_SMALL_PATH = "assets/img/logo-small.png";
export const MODULE_FAVICON_PATH = "/favicon.png";
export const MODULE_FAVICON_ICO_PATH = "/favicon.ico";

/** Noms commerciaux affichés à côté des pictos standalone (core/logos). */
export const MODULE_COMMERCIAL_NAMES: Record<string, string> = {
  suite: "ITaaS Suite",
  product: "ITaaS Product",
  inventory: "ITaaS Inventory",
  autoid: "ITaaS AutoID",
  erp: "ITaaS ERP",
  rh: "ITaaS RH",
  workforce: "ITaaS Workforce",
  recruitment: "ITaaS Recruitment",
  attendance: "ITaaS Attendance",
  security: "ITaaS Security",
  notifications: "ITaaS Notifications",
  billing: "ITaaS Invoice",
  crm: "ITaaS CRM",
  hospitol: "ITaaS Hospitol",
  legal: "ITaaS Legal",
  edu: "ITaaS Edu",
  mineportal: "ITaaS MinePortal",
  subportal: "ITaaS SubPortal",
  finance: "ITaaS Finance",
  procurement: "ITaaS Procurement",
  comex: "ITaaS Comex",
  iam: "ITaaS IAM",
};

export function getModuleCommercialName(moduleId: string): string {
  return MODULE_COMMERCIAL_NAMES[moduleId] ?? moduleId;
}
